export const tags = {
  system: {
    badge: 'Sistema',
  },
} as const
